<template>
  <div>
    <Banners mode="sliderBanner" />
  </div>
</template>

<script>
import appConfig from '@/app.config'
import Banners from '../../../components/dadban/banners/Banners.vue'

export default {
  page: {
    title: 'مدیریت اسلایدر صفحه اصلی',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  name: 'dadban-slider-banner',
  components: { Banners },
}
</script>
